import { useStateValue } from '../../context/StateValueContext';
import { PERMISSIONS } from '../../constants/permissions';
import AdminEthoca from './Ethoca';
import ClientEthoca from '../ClientAlerts/ClientEthoca';

export default function EthocaSwitcher() {
  const [{ user }] = useStateValue();

  if (user?.permissions?.includes(PERMISSIONS.ALERTS_ALL)) {
    return <AdminEthoca />;
  }

  return <ClientEthoca />;
}
